<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8557 3L13 3L13 4.43273L6.99432 11L5.76607 9.65726L11.8557 3Z" fill="currentColor" />
    <path d="M4.55079 8.32345L1 4.44167L1 3.00188L2.1298 3.00188L5.77259 6.986L4.55079 8.32345Z" fill="currentColor" />
  </svg>
</template>
